import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Outlet, useLocation } from 'react-router-dom';
import { StepNav } from '../../../../../../Components/Reuseables';
import { useStateMachine } from 'little-state-machine';
import clearStore from '../clearStore';

const STEPS = ['Step1', 'Step2', 'Step3', 'Step4', 'Step5', 'Step6'];

function Layout() {
  const location = useLocation();
  let pathname = location.pathname;
  const { actions } = useStateMachine({ clearStore });

  useEffect(() => {
    return () => {
      actions.clearStore();
    };
  }, []);

  const [step, setStep] = useState(
    pathname.split('/').includes('admin') ? pathname.split('/')[4] : pathname.split('/')[3]
  );
  useEffect(() => {
    setStep(
      pathname.split('/').includes('admin') ? pathname.split('/')[4] : pathname.split('/')[3]
    );
  }, [pathname]);
  return (
    <div className="card content-section">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="mb-0 text-primary">
            <FormattedMessage id="organization" />
          </h1>
          <StepNav>
            {STEPS.map((title, index, { length }) => {
              let stepName;
              switch (step) {
                case undefined:
                  stepName = STEPS[0];
                  break;
                default:
                  stepName = STEPS[parseInt(step)];
              }
              let _class = 'bg-primary text-light';
              if (index == 0) {
                _class = `${_class} first-step`;
              }
              if (index + 1 === length) {
                _class = `${_class} last-step`;
              }
              return (
                <div key={index} className={title === stepName ? _class : ''}>
                  <span>
                    <small>{title}</small>
                  </span>
                </div>
              );
            })}
          </StepNav>
        </div>
      </div>
      <div className="card-body pt-2 ">
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
